<template>
  <Popup
    class="dialog"
    v-model:show="show"
  >
    <Icon
      class="dialog__close"
      name="close-f-2"
      @click="show = false"
    />
    <div class="dialog__content">
      <slot />
    </div>
    <slot name="footer" />
  </Popup>
</template>

<script setup>
import { Popup } from '@/components/Popup'
import { Icon } from '@/components/Icon'

const show = defineModel('show', { type: Boolean })
</script>

<style lang="less">
.dialog {
  background-color: #FFFFFF;

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 24px;
    cursor: pointer;
  }

  &__content {
    padding: 24px 32px;
  }
}
</style>
